var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.species.speciesList
    ? _c(
        "transition-group",
        {
          staticClass: "row justify-start q-col-gutter-sm",
          attrs: { name: "list", tag: "div", id: "gallery-container" }
        },
        _vm._l(_vm.filteredSpeciesList, function(woodSpecies) {
          return _c("SpeciesTeaser", {
            key: woodSpecies.uid,
            staticClass: "col-6 col-sm-4 col-md-2 species-teaser",
            attrs: { species: woodSpecies }
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }